export default {
  cardTypesResults: [],
};
